// H6 全局配置（TDesign）：只读展示数据库 parttime_global_config 的全部配置，
// 优先展示各页面「分页每页条数」（page_size_H1/H2/H3/H5），此处仅查看不允许修改。
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Tag } from 'tdesign-react';
import { parttimeApi } from '../../api/parttime';

// 分页配置 key → 页面描述（仅用于标注，数值一律读后端）
const PAGE_SIZE_NAMES = {
  page_size_H1: '兼职申请',
  page_size_H2: '数据分配',
  page_size_H3: '数据核对',
  page_size_H5: '对账结算',
};

export default function ParttimeConfig() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await parttimeApi.configList();
      setItems((res && res.items) || []);
    } catch (e) {
      setError(e && e.message ? e.message : String(e || '加载失败'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // 配置类型判定（cos 相关 = 类型 cos；secretId/secretKey 更敏感，优先级最高）
  const isSecretKey = (k) => k === 'cos.secretId' || k === 'cos.secretKey' || /secret/i.test(k || '');
  const isCosKey = (k) => (k || '').startsWith('cos.');
  const isPageSizeKey = (k) => !!PAGE_SIZE_NAMES[k];

  // 分页配置优先展示
  const sorted = [...items].sort((a, b) =>
    (isPageSizeKey(a && a.configKey) ? 0 : 1) - (isPageSizeKey(b && b.configKey) ? 0 : 1));

  const columns = [
    { colKey: 'configKey', title: '配置Key', cell: ({ row }) => <code>{row.configKey}</code> },
    {
      colKey: 'remark', title: '说明',
      cell: ({ row }) => isPageSizeKey(row.configKey)
        ? `${PAGE_SIZE_NAMES[row.configKey]}（分页每页条数）`
        : (row.remark || ''),
    },
    {
      colKey: 'type', title: '类型',
      cell: ({ row }) => isSecretKey(row.configKey)
        ? <Tag theme="danger" variant="light">敏感数据</Tag>
        : isCosKey(row.configKey) ? <Tag theme="primary" variant="light">cos</Tag>
        : isPageSizeKey(row.configKey) ? <Tag variant="light">分页每页条数</Tag>
        : <Tag variant="light">其他</Tag>,
    },
    {
      colKey: 'configValue', title: '配置值',
      cell: ({ row }) => <b>{isSecretKey(row.configKey) ? '****' : (row.configValue || '')}</b>,
    },
  ];

  return (
    <div className="pt-card">
      <p className="pt-search-title">全局配置</p>
      {error
        ? <p style={{ color: '#e34d59' }}>{error}</p>
        : <Table
            rowKey="configKey"
            resizable
            columns={columns}
            data={sorted}
            loading={loading}
            empty={<span style={{ color: '#bbb' }}>暂无配置</span>}
          />}
    </div>
  );
}